import React from "react";
import { useTranslation } from "react-i18next";

export const NotAvailable = () => {
  const { t } = useTranslation();

  return <span>{t("viewProduct.informationNotSetLabel")}</span>;
};
